import { Provider } from 'react-redux';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index.jsx';
import { IntlProvider } from 'dibs-react-intl';
import { useLazyLoadQuery, RelayEnvironmentProvider } from 'react-relay';

import { HpSharedLayout } from '../homepage/HpSharedLayout.tsx';
import { homepageRootQuery } from '../queries/homepageRoot.js';
import serverVars from 'server-vars';
import { hydrateRoot } from 'react-dom/client';
import { HomePageContextProvider } from '../homepage/HomePageContext.tsx';
import { getRelayEnvironment } from '../utils/relayModernEnvironment.js';
import { Error500Layout } from 'dibs-buyer-layout/exports/error500.tsx';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary.tsx';
import { getIsBotOnClient } from 'dibs-buyer-layout/exports/botHelpers.ts';
import { HomepagePersonalizedCollectionsProvider } from 'dibs-personalized-collections/exports/PersonalizedCollectionsContext.ts';
import { isHpSponsoredListingsModuleVariant } from '../homepage/helpers/abTestHelpers.ts';

const homepageUserGroup = serverVars.get('homepageUserGroup');

const ComponentWrapper = () => {
    const data = useLazyLoadQuery(homepageRootQuery, serverVars.get('relayVariables'), {
        fetchPolicy: 'store-only',
    });
    return <HpSharedLayout homepageUserGroup={homepageUserGroup} viewer={data.viewer} />;
};

initializeDBL().then(({ store }) => {
    const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ErrorBoundary fallback={({ error }) => <Error500Layout error={error} />}>
                <RelayEnvironmentProvider environment={environment}>
                    <HomePageContextProvider
                        isBot={getIsBotOnClient()}
                        isMobile={serverVars.get('settings.isMobile')}
                        isTablet={serverVars.get('settings.isTablet')}
                        isDesktop={serverVars.get('settings.isDesktop')}
                        userType={homepageUserGroup}
                        // userType is only added as a query param for logged-in users
                        isLoggedInUser={!!serverVars.get('userType')}
                        priceBookName={serverVars.get('relayVariables.priceBookName')}
                        isTopDisplayAdEnabled={serverVars.get('isTopDisplayAdEnabled')}
                        isBottomDisplayAdEnabled={serverVars.get('isBottomDisplayAdEnabled')}
                        isHpSponsoredListingsModuleVariant={isHpSponsoredListingsModuleVariant()}
                        isRemoveTopHeroBannerTestVariant={serverVars.get(
                            'isRemoveTopHeroBannerTestVariant'
                        )}
                        isEvergreenCollectionsTestVariant={serverVars.get(
                            'isEvergreenCollectionsTestVariant'
                        )}
                        isPersonalizedCollectionTestVariant={serverVars.get(
                            'isPersonalizedCollectionTestVariant'
                        )}
                        isSecondNetflixCarouselTestVariant={serverVars.get(
                            'isSecondNetflixCarouselTestVariant'
                        )}
                    >
                        <HomepagePersonalizedCollectionsProvider
                            isTestVariant={serverVars.get('isPersonalizedCollectionTestVariant')}
                        >
                            <Provider store={store}>
                                <ComponentWrapper />
                            </Provider>
                        </HomepagePersonalizedCollectionsProvider>
                    </HomePageContextProvider>
                </RelayEnvironmentProvider>
            </ErrorBoundary>
        </IntlProvider>
    );
});
